import React from 'react';
import AppRouter from './pages/Router';
import { create } from 'jss';
import rtl from 'jss-rtl';
import {
  StylesProvider,
  jssPreset,
  ThemeProvider,
  createMuiTheme
} from '@material-ui/core/styles';
import './assets/styles/fonts.css';
import initializeAxios from './api/initialize'

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const theme = createMuiTheme({
  direction: 'rtl',
  typography: {
    fontFamily: 'Vazir'
  }
});

function App() {
  initializeAxios()
  return (
    <StylesProvider jss={jss}>
      <ThemeProvider theme={theme}>
        <AppRouter />
      </ThemeProvider>
    </StylesProvider>
  );
}

export default App;
